import store from "@/store";
import { readContract } from "@wagmi/core";

const setupConfig = () => {
  const { freeGasManager } = store.getState()?.contract?.infoWagmiConfig ?? {};
  return freeGasManager;
};

/**
 * todo: get gas limit
 * @returns hours
 */
const userGasBalanceLimit = async () => {
  try {
    const number = await readContract({
      ...setupConfig(),
      functionName: "userGasBalanceLimit",
      args: [],
    });
    return Number(number);
  } catch (err) {
    throw err;
  }
};

/**
 * todo: get hours to free gas
 * @returns second/3600
 */
const period = async () => {
  try {
    const number = await readContract({
      ...setupConfig(),
      functionName: "period",
      args: [],
    });
    return Number(number) / 3600;
  } catch (err) {
    return 24;
  }
};

export const freeGasManagerService = {
  userGasBalanceLimit,
  period,
};
